import {Injectable} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import {SalesHandoverData} from "./sales-handover.data";
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";

@Injectable()
export class SalesHandoverService {
    constructor(private auth: AuthApiService, private http: HttpClient) {
    }

    async updateSalesHandover(venueId: string, data: SalesHandoverData): Promise<void> {
        return firstValueFrom(this.http.post<void>("/fonzie/customer-instance-venue/" + venueId + "/sales-handover", data, {headers: this.auth.getHttpHeaderOptions()}));
    }

}
